import { render } from "./OfferTrip.vue?vue&type=template&id=0c1a48f8"
import script from "./OfferTrip.vue?vue&type=script&lang=js"
export * from "./OfferTrip.vue?vue&type=script&lang=js"

import exportComponent from "/home/joeyd/Documents/Work/Clients/Taxined/Development/TripTrader/triptrader-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__